import React, { useState, useEffect } from "react";
import { Modal, Form, Spinner } from "react-bootstrap";
import Button from "../../../global/button";
import { toast } from "react-toastify";
import { editBookingSpecialRequestApi } from "../../../../api/dashboardApi";

// /** Function to open email property modal */
function EditSpecialRequestModel(props) {
  const { onHide, bookingId, specialRequest, setSpecialRequest } = props;
  const [specialRequestNew, setSpecialRequestNew] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();

    if (!specialRequest) return;
    if (loading) return;
    if (specialRequestNew === specialRequest) return;

    setLoading(true);

    const data = {
      bookingId,
      specialRequest: specialRequestNew,
    };

    await editBookingSpecialRequestApi(data)
      .then((res) => {
        setSpecialRequest(specialRequestNew);
        toast.success(res.message);
      })
      .catch((err) => {
        toast.error(err.message);
      })
      .finally(() => {
        setLoading(false);
        onHide();
      });
  };

  const handleClose = () => {
    onHide();
    setSpecialRequestNew("");
  };

  useEffect(() => {
    setSpecialRequestNew(specialRequest);
  }, [specialRequest]);

  return (
    <Modal className="more-popups" {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Edit special request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={submit}>
          <Form.Group className="mb-3" controlId="message-box">
            <Form.Control
              value={specialRequestNew}
              as="textarea"
              rows={2}
              placeholder="Type your special request here..."
              maxLength={255}
              onChange={(e) => {
                const value = e.target.value;
                setSpecialRequestNew(value);

                if (value.length === 255) {
                  setError("Please use up to 255 characters only.");
                } else {
                  setError("");
                }
              }}
            />
            {error && <div className="text-danger mt-1">{error}</div>}
          </Form.Group>
          <Form.Group className="make-request-popup-btns ">
            <Button onClick={handleClose} variant="secondary" size="sm">
              Cancel
            </Button>
            <Button size="sm" type="submit" disabled={specialRequestNew === specialRequest}>
              {loading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
              &nbsp; {!loading && "Save"}
            </Button>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

/** Main Component Function */
function EditSpecialRequest({ bookingId, specialRequest, setSpecialRequest }) {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <button className="rd-edit-sp-request-btn" onClick={() => setModalShow(true)}>
        Edit
      </button>

      <EditSpecialRequestModel
        show={modalShow}
        onHide={() => setModalShow(false)}
        bookingId={bookingId}
        specialRequest={specialRequest}
        setSpecialRequest={setSpecialRequest}
      />
    </>
  );
}

export default EditSpecialRequest;
